import { $api } from "@/shared/api";

// Pro и автоплатёж текущего игрока (`GET /api/billing/me`): до какого числа Pro, статус
// автоплатежа, цена и включена ли оплата.
export const billingStatusQueryOptions = () => $api.queryOptions("get", "/api/billing/me");
